import { Button, Grid, Menu, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';

import { SelectMultipleInput } from '../../../components/Forms/selectMultipleInput';
import search from './../../../assets/images/h-search.svg';
import useStyles from './documentsStyle';

type DocumentFilterProps = {
  setAnchorEl: (src: any) => void;
  anchorEl: any;
  open: boolean | any;
  filters: any;
  setFilters: (src: any) => void;
  storeFilter: any;
  canSearchDriver: boolean;
  canSearchUnit: boolean;
};

const DocumentsFilter: React.FC<DocumentFilterProps> = (
  props: DocumentFilterProps,
) => {
  const {
    anchorEl,
    filters,
    open,
    setAnchorEl,
    setFilters,
    storeFilter,
    canSearchDriver,
    canSearchUnit,
  } = props;
  const classes = useStyles();

  useEffect(() => {
    setFilters((pre: any) => ({
      ...pre,
      driverName:
        storeFilter && storeFilter.driverName ? storeFilter.driverName : '',
      fileName: storeFilter && storeFilter.fileName ? storeFilter.fileName : '',
      tags:
        storeFilter && storeFilter.tags && storeFilter.tags.length
          ? storeFilter.tags
          : [],
      vinNumber:
        storeFilter && storeFilter.vinNumber ? storeFilter.vinNumber : '',
    }));
  }, [open, setFilters, storeFilter]);
  return (
    <Menu
      id="basic-menu"
      className="filter"
      anchorEl={anchorEl}
      open={open}
      onClose={() => setAnchorEl(null)}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}>
      <Grid style={{ padding: '1rem' }}>
        <Typography component={'h3'}>TAGS</Typography>
        <div
          className={classes.borderBottom}
          style={{ padding: '.5rem 0px 1rem 0rem' }}>
          <SelectMultipleInput
            name="tags"
            value={filters.tags}
            onChangeText={(arr: any) =>
              setFilters((pre: any) => ({ ...pre, tags: arr }))
            }
            optionsList={[
              'Annual',
              'Annual Inspection',
              'APTO',
              'Articles',
              'Authority Letter',
              'Background Authorization',
              'Bond-Brokerage',
              'Bond-OR',
              'CA # Letter',
              'Cab Card',
              'Certificate of Status',
              'Clearinghouse Query',
              'COI',
              'Driver',
              'Driver Application',
              'Driver License',
              'DOT',
              'DQ',
              'ELD Report',
              'EPN Report',
              'Equipment Lease',
              'Fictitious Name Letter',
              'FEIN Letter',
              'Fuel Card Report',
              'Fuel Receipts',
              'Fuel Taxes',
              'IFTA',
              'Hazmat',
              'IRP',
              'HOS Report',
              'KY',
              'Local Tag',
              'Lease Agreement',
              'Lease Termination',
              'Medical Card',
              'Medical Long Form',
              'MVR',
              'NJ Business Registration',
              'NJ Foreign Entity',
              'NM',
              'NY',
              'OR',
              'Participation Letter',
              'Pre-employment',
              'Permanent',
              'Permits',
              'Periodic Inspection',
              'PEV Report',
              'Pool Membership',
              'Post Accident',
              'Power Unit',
              'PSP Authorization',
              'PSP Result',
              'Random',
              'Random Selection',
              'Reasonable Suspicion',
              'Refusal to Test',
              'Result-Background Check',
              'Result-BAT',
              'Result-DT',
              'Return to Duty',
              'RKA',
              'Road Taxes',
              'Safety Policy',
              'Safety Lease',
              'SAP',
              'SCAC',
              'Temporary',
              'Title',
              'Trailer',
              'Training Acknowledgement',
              'Training Certificate',
              'Trip Sheets',
              'VQ',
            ].map((label) => ({ label, value: label }))}
            selectClassName={classes.inputF}
            defaultOptionLabel="Select tags"
            size="small"
          />
        </div>
        <Typography component={'h3'}>FILE NAME</Typography>
        <Grid className={classes.borderBottom}>
          <Grid container className={classes.searchBox}>
            <Grid item md={2} className={classes.dFlexJA}>
              <img className={classes.filterIcon} src={search} alt="search" />
            </Grid>
            <Grid item md={10}>
              <TextField
                type={'text'}
                sx={{
                  input: { backgroundColor: 'unset', color: '#fff' },
                }}
                // value={filters.fileName}
                defaultValue={
                  storeFilter && storeFilter.fileName
                    ? storeFilter.fileName
                    : ''
                }
                className={classes.inputF}
                placeholder="Search"
                onChange={(e: any) =>
                  setFilters((pre: any) => ({
                    ...pre,
                    fileName: e.target.value,
                  }))
                }
              />
            </Grid>
          </Grid>
        </Grid>
        {canSearchDriver && (
          <Typography component={'h3'}>DRIVER NAME</Typography>
        )}
        {canSearchDriver && (
          <Grid className={classes.borderBottom}>
            <Grid container className={classes.searchBox}>
              <Grid item md={2} className={classes.dFlexJA}>
                <img className={classes.filterIcon} src={search} alt="search" />
              </Grid>
              <Grid item md={10}>
                <TextField
                  type={'text'}
                  sx={{
                    input: { backgroundColor: 'unset', color: '#fff' },
                  }}
                  defaultValue={
                    storeFilter && storeFilter.driverName
                      ? storeFilter.driverName
                      : ''
                  }
                  className={classes.inputF}
                  placeholder="Search"
                  onChange={(e: any) =>
                    setFilters((pre: any) => ({
                      ...pre,
                      driver: undefined,
                      driverName: e.target.value,
                    }))
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        {canSearchUnit && <Typography component={'h3'}>VIN NUMBER</Typography>}
        {canSearchUnit && (
          <Grid className={classes.borderBottom}>
            <Grid container className={classes.searchBox}>
              <Grid item md={2} className={classes.dFlexJA}>
                <img className={classes.filterIcon} src={search} alt="search" />
              </Grid>
              <Grid item md={10}>
                <TextField
                  type={'text'}
                  sx={{
                    input: { backgroundColor: 'unset', color: '#fff' },
                  }}
                  defaultValue={
                    storeFilter && storeFilter.vinNumber
                      ? storeFilter.vinNumber
                      : ''
                  }
                  className={classes.inputF}
                  placeholder="Search"
                  onChange={(e: any) =>
                    setFilters((pre: any) => ({
                      ...pre,
                      unit: undefined,
                      vinNumber: e.target.value,
                    }))
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid container>
          <Grid item md={6} className={classes.resetF}>
            <Button
              variant={'text'}
              className={'d-flex-ja '.concat(classes.resetF)}
              onClick={() => setAnchorEl('reset')}
              disabled={
                !(
                  storeFilter.fileName ||
                  storeFilter.driverName ||
                  storeFilter.vinNumber ||
                  (storeFilter.tags && storeFilter.tags.length) ||
                  storeFilter.driver ||
                  storeFilter.unit
                )
              }>
              RESET FILTERS
            </Button>
          </Grid>
          <Grid item md={6}>
            <Typography
              component={'button'}
              className={classes.filterBtn}
              style={{
                backgroundColor: !(
                  filters.fileName ||
                  filters.driverName ||
                  filters.vinNumber ||
                  (filters.tags && filters.tags.length)
                )
                  ? '#d3d3d3'
                  : '#DEC330',
              }}
              onClick={() => setAnchorEl('apply')}
              disabled={
                !(
                  filters.fileName ||
                  filters.driverName ||
                  filters.vinNumber ||
                  (filters.tags && filters.tags.length)
                )
              }>
              APPLY FILTER
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Menu>
  );
};

export default observer(DocumentsFilter);
